module.exports = __webpack_public_path__ + "img/researchCenter.1217c48e.png";